import { ReactElement, useState } from 'react';
import { Stack } from '@mui/material';
import {
  DateFromFilter,
  DateToFilter,
  MerchantFilter,
  PeriodFilter,
  RegionFilter,
} from '../../../../Components/ReportsWidget/Filters';
import ReportWidget from '../../../../Components/ReportsWidget/Widget';
import type { ClicksByMerchantsResource } from '../../../../Entities/ClicksByMerchant';
import { useCanAccess } from 'react-admin';
import ClicksByMerchantDataTable from './ClicksByMerchantDataTable';
import ExportButton from './ExportButton';
import PreviewButton from './PreviewButton';

export default function ClicksByMerchantWidget(): ReactElement {
  const [hasPreview, setHasPreview] = useState(false);
  const [records, setRecords] = useState<ClicksByMerchantsResource[]>([]);
  const [isPending, setIsPending] = useState(false);
  const [startDateLabel, setStartDateLabel] = useState('');
  const [endDateLabel, setEndDateLabel] = useState('');
  const merchantStatusesListAccess = useCanAccess({
    resource: 'merchant_statuses',
    action: 'list',
  });

  return (
    <Stack spacing={1}>
      <ReportWidget
        resource="clicks_by_merchants"
        filters={[RegionFilter, PeriodFilter, DateFromFilter, DateToFilter, MerchantFilter]}
        defaultValues={{ period: 'this_month' }}
        actions={
          <>
            <PreviewButton
              autoPreviewOnMount
              onPreviewStart={({ startDateLabel, endDateLabel }) => {
                setStartDateLabel(startDateLabel);
                setEndDateLabel(endDateLabel);
                setRecords([]);
                setHasPreview(true);
                setIsPending(true);
              }}
              onPreviewSuccess={(records) => {
                setRecords(records);
                setIsPending(false);
              }}
              onPreviewError={() => {
                setIsPending(false);
              }}
            />
            <ExportButton />
          </>
        }
      />
      {hasPreview && (
        <ClicksByMerchantDataTable
          data={records}
          isPending={isPending}
          startDateLabel={startDateLabel}
          endDateLabel={endDateLabel}
          canListMerchantStatuses={merchantStatusesListAccess.canAccess ?? false}
        />
      )}
    </Stack>
  );
}
